import { useEffect } from "react";
import { useGmailConnectorStore } from "./store/gmailConnectorStore";

export function useGmailConnectorStatus() {
  const isLoadingGmail = useGmailConnectorStore((s) => s.isLoadingGmail);
  const isGmailConnected = useGmailConnectorStore((s) => s.isGmailConnected);
  const canSendGmail = useGmailConnectorStore((s) => s.canSendGmail);
  const refresh = useGmailConnectorStore((s) => s.refresh);

  useEffect(() => {
    if (isLoadingGmail) void refresh();
  }, [isLoadingGmail, refresh]);

  return { isLoadingGmail, isGmailConnected, canSendGmail, refresh };
}
